import { Component } from 'react';
import { connect } from 'react-redux';

import { Layout, Title, NeedHelp } from 'common/components/layout';
import SubMenu from 'profile/common/SubMenu';
import { getOrder } from 'redux/orders/actions';

// import OrderSummary from './components/OrderSummary';
import CustomerDetails from './components/CustomerDetails';
import FulfillmentDetails from './components/FulfillmentDetails';
import GiftMessage from './components/GiftMessage';
import OrderDetails from './components/OrderDetails';
import OrderSummaryReceipt from './components/OrderSummaryReceipt';
import ShippingInstructions from './components/ShippingInstructions';
// import OrderShipping from './components/OrderShipping';
// import OrderShipmentUpdates from './components/OrderShipmentUpdates';

class OrderHistoryView extends Component {
  componentDidMount() {
    const { props } = this;
    props.getOrder(props.match.params.id);
  }

  render() {
    const { orders, settings, customer, match } = this.props;
    const orderId = match.params.id;
    if (!settings.data || !orders.data || !customer.data) {
      return (
        <Layout title="Order View" loading>
          <Title>Your Account</Title>
          <SubMenu />
        </Layout>
      );
    }
    const order = orders.data[orderId];
    return (
      <Layout title={`Order No. ${order.orderNumber}`}>
        <Title>Your Account</Title>
        <SubMenu />

        <div className="c7-account__order-detail">
          <h2>
            <span>Order No. {order.orderNumber}</span>
            Thank you {customer.data.firstName}!
          </h2>

          <OrderSummaryReceipt order={order} settings={settings} />

          <div className="c7-account__order-detail__customer-details">
            {/* <OrderShipping />
            <OrderShipmentUpdates />
            */}
            <OrderDetails order={order} settings={settings} />
            <FulfillmentDetails order={order} settings={settings} />
            <CustomerDetails order={order} />
            <GiftMessage order={order} />
            <ShippingInstructions order={order} />
            <NeedHelp
              type="Order"
              orderNumber={order.orderNumber}
              customer={customer.data}
              settings={settings}
            />
          </div>
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  orders: state.order,
  settings: state.setting,
  customer: state.customer
});

export default connect(mapStateToProps, {
  getOrder
})(OrderHistoryView);
